import React, { useState, useEffect } from 'react'
import './edit.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import {serverTimestamp, setDoc, doc, addDoc, collection, getDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import Link from '@mui/material/Link';
import { Box, Breadcrumbs, Button, FormControl, InputLabel, MenuItem, Select, TextField, Typography, OutlinedInput, Chip } from '@mui/material'
import { useNavigate, useParams } from "react-router-dom"
import { Password } from '@mui/icons-material';
import { getFunctions, httpsCallable } from "firebase/functions";
import { useTheme } from '@material-ui/core/styles';
// import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { allRegions, allAreas, allOutlets, openList } from '../../../data/dataSource'
import { deleteObject, getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
// import { functions } from '../../../firebase';


const scores = [

  { label: 'Fair', value: 'Fair' },

  { label: 'Good', value: 'Good' },

  { label: 'Excellent', value: 'Excellent' },

];



const Edit = ({}) => {

  const [message, setMessage] = useState('')

  const navigate = useNavigate();

 const [servicequalitystatus, setServicequalitystatus] = useState("")

  const [servicespeedstatus, setServicespeedstatus] = useState("")

  const [staffbehaviouralstatus, setStaffbehaviouralstatus] = useState("")

  const [outletambiencestatus, setOutletambiencestatus] = useState("")

  const [valueaverageformoneystatus, setValueaverageformoneystatus] = useState("")

  const [customeraveragereturnratestatus, setCustomeraveragereturnratestatus] = useState("")

  const [whatsappmessage, setWhatsappmessage] = useState("")

  const [isloading, setIsloading] = useState(false)


  const [errorservicequalitystatus, setErrorservicequalitystatus] = useState(false)

  const [errorservicespeedstatus, setErrorservicespeedstatus] = useState(false)

  const [errorstaffbehaviouralstatus, setErrorstaffbehaviouralstatus] = useState(false)

  const [erroroutletambiencestatus, setErroroutletambiencestatus] = useState(false)

  const [errorvalueaverageformoneystatus, setErrorvalueaverageformoneystatus] = useState(false)

  const [errorcustomeraveragereturnratestatus, setErrorcustomeraveragereturnratestatus] = useState(false)

  const [errorwhatsappmessage, setErrorwhatsappmessage] = useState(false)

  const {weekendmessageId} = useParams()

  const date = new Date().toDateString()



  const getWeekendMessageData = async() => {

    const docRef = doc(db, "weekendWhatsappMessages", weekendmessageId);

    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {

      // setAdvertData(docSnap.data())
      setServicequalitystatus(docSnap.data().servicequalitystatus)
      setServicespeedstatus(docSnap.data().servicespeedstatus)
      setStaffbehaviouralstatus(docSnap.data().staffbehaviouralstatus)
      setOutletambiencestatus(docSnap.data().outletambiencestatus)
      setValueaverageformoneystatus(docSnap.data().valueaverageformoneystatus)
      setCustomeraveragereturnratestatus(docSnap.data().customeraveragereturnratestatus)
      setWhatsappmessage(docSnap.data().whatsappmessage)

      // console.log(outletData)
    } else {
      // doc.data() will be undefined in this case
      console.log("No such document!");
    }
  }

  

  useEffect(()=>{

    getWeekendMessageData()

  }, [])




  
  const handleEditWeekendMessage = async(e) => {

    e.preventDefault()
  
    if(servicequalitystatus === "") {

      return setErrorservicequalitystatus('This field is required')
      
    }

     if(servicespeedstatus === "") {

      return setErrorservicespeedstatus('This field is required')
    
    }

    if(staffbehaviouralstatus === "") {

      return setErrorstaffbehaviouralstatus('This field is required')
    
    }

    if(outletambiencestatus === "") {

      return setErroroutletambiencestatus('This field is required')
      
    }

     if(valueaverageformoneystatus === "") {

      return setErrorvalueaverageformoneystatus('This field is required')
      
    }


    if(customeraveragereturnratestatus === "") {

      return setErrorcustomeraveragereturnratestatus('This field is required')
      
    }


    if(whatsappmessage === "") {

      return setErrorwhatsappmessage('This field is required')
    
    }

    setIsloading(true)


      try{
           
        await setDoc(doc(db, "weekendWhatsappMessages", weekendmessageId), {


          servicequalitystatus : servicequalitystatus,

          servicespeedstatus :  servicespeedstatus,

          staffbehaviouralstatus : staffbehaviouralstatus,

          outletambiencestatus : outletambiencestatus,

          valueaverageformoneystatus : valueaverageformoneystatus,

          customeraveragereturnratestatus : customeraveragereturnratestatus,

          whatsappmessage : whatsappmessage,
        
          
        });

        navigate("/weekendmessages")
        
      }catch (err) {

        console.log(err);

      } finally{

        setIsloading(false)

      }

  }




  // console.log(role)

  return (
    <div className="new">
      <Sidebar/>
      <div className="newContainer">
      <Navbar/>
        <div className='top'>
          <div className='topLeft'><h1>Edit Weekend Messages</h1></div>
          
          <div className='topRight'>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              Home
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href={`/weekendmessages/${weekendmessageId}`}
            >
              Weekend Message List
            </Link>
            <Typography color="green">Edit Weekend Message</Typography>
          </Breadcrumbs>
          </div>
        </div>
         <div>
              <span>{message}</span>
            </div>
        <div className='top'>
         
           
            <div className="left">


            <div className='form'  >
         

               
              {/* /////////////// */}



                  <div style={{display: 'flex', flexDirection:'column', gap:10, width:800, marginBottom:20, marginRight:10}}>

                    <p>Whatsapp Message</p> 

                    <TextField
                        type="text"
                        name="whatsappmessage"
                        placeholder="Enter Whatsapp Message"
                        value={whatsappmessage}
                        multiline
                        minRows={10}
                        maxRows={10}
                        onChange={(e) => setWhatsappmessage(e.target.value)}
                        style={{width:'100%', backgroundColor:'#f8ecfb', width:'100%'}}
                    />


                     {

                          errorwhatsappmessage &&

                          <span style={{color:'red', fontSize:10}}>{errorwhatsappmessage}</span>

                      }   


                </div>      

                    
                <Button 
                  onClick={handleEditWeekendMessage}
                  style={{width:800, height:60, backgroundColor:'#9900CC', paddingTop:10, paddingBottom:10, color:'white', marginTop:20, borderRadius:30}}>{isloading ? "...Loading": 'Edit Message'}
                </Button>
            </div>
            </div>
          </div>
        </div>
      </div>
  )
}

export default Edit










